import React from "react";

const Contacts = () => {
  return (
    <section className="section about-section">
      <h2 className="section-title">Contacts</h2>
      <h3>Email: <span>cocktailmaker@google.com</span> </h3>
      <h3>Adres <span>Russia, street S.P. 77, buildin nummber 234</span> </h3>
      <h3>Phone <span>+ 7 8989 90889 0900</span> </h3>
    </section>
  );
};

export default Contacts;
